export default {
  footer: '© {year} • AdminDigital • Um produto {company} • Menos discurso, mais resultado.',
  footerCompany: {
    name: 'Núcleo P',
    tagline: 'Núcleo P – Tecnologia e Estratégia',
    url: 'https://nucleop.com'
  },
  menu: {
    product: 'Home',
    modules: 'Módulos',
    contact: 'Contato',
    blog: 'Blog',
    login: 'Login',
    signup: 'Cadastre-se'
  },
  seo: {
    title: 'AdminDigital | Nucleo P ',
    description: 'Página do AdminDigital',
    robots: false
  },
  productName: 'AdminDigital'
}

